module.exports = __webpack_public_path__ + "static/img/8.0df1ce07.jpg";